/**
 * Carousel Component
 * @module patterns/components/banners/asset-hero-banner
 */

import Glide from '@glidejs/glide';

import { type App } from '~/app';

import JsController from '../../js-controller';

export default (app: App) => {

    const controller = new JsController(app, 'Asset Hero');
    controller.addMountFunction(() => {
        mountPromoTile(controller);
    })

    return controller.init();
}

export function mountPromoTile( controller: JsController ) {
    const elements = document.querySelectorAll<HTMLElement>(`.promo-tile`);
    let index = 0;
    for (const element of elements) {
        mountCarousel(controller, element, index);
        index++;
    }
}

// Handle scroll arrow click
const mountCarousel = (controller: JsController, element: HTMLElement, carouselIndex: number) => {
    const imageCarousel = element.querySelector('.glide__track');
    if (imageCarousel) {
        const indexClass = `promo-tile-${carouselIndex}`;
        element.classList.add(indexClass);
        const glide: Glide = new Glide(`.${indexClass}`, {
            type: 'slider',
            perView: 1,
            startAt: 0,
            gap: 0,
        })
            .mount();
        controller.addCarouselInstance(glide);
    }
}